export default __webpack_public_path__ + "static/media/FSMeridian-Regular.e77ba980.woff";